module.exports = __webpack_public_path__ + "images/file_icons_v2/key-8ea0f0fad6dccdf721654eb4d4c450a6.svg";